import React, { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import get from 'lodash/get';
import { AvatarLarge } from '../../components';
import { getLatestListings, limitText } from './utils';

import LatestNewsPopup from './LatestNewsPopup';

import css from './LatestNewsSection.module.scss';
import NewsImage from '../NewsImage/NewsImage';

const Swiper =
  typeof window !== 'undefined'
    ? require('swiper/react').Swiper
    : dynamic(() => import('swiper/react'), {
        ssr: false,
      });
const SwiperSlide =
  typeof window !== 'undefined'
    ? require('swiper/react').SwiperSlide
    : dynamic(() => import('swiper/react'), {
        ssr: false,
      });
const Navigation =
  typeof window !== 'undefined'
    ? require('swiper').Navigation
    : dynamic(() => import('swiper'), {
        ssr: false,
      });

function LatestNewsSection(props) {

  const { onManageDisableScrolling, searchedCategory } = props;

  const [news, setNews] = useState([]);
  const [slideIndex, setSlideIndex] = useState(-1);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      require('swiper/css');
      require('swiper/css/bundle');
      require('swiper/css/navigation');
    }

    getLatestListings({
      pub_listingType: 'provider',
      pub_hasAnyNews: true,
      sort: 'pub_latesNewsAddedDate'
    })
      .then(resp => {
        const container = [];
        resp.forEach(l => {
          
          const news = get(l, 'attributes.publicData.news', []);
          const content = get(l, 'attributes.publicData.content', []);
          const listingId = get(l, 'id.uuid', null);
          const posts = [...news, ...content];

          const targetNews =
            (Array.isArray(posts) ? posts : []).filter(
              n => n && n?.title && n?.id
            ) || [];
          targetNews
            .filter(n => {
              if (searchedCategory) {
                return n?.category?.find(nCat => searchedCategory?.includes(nCat));
              } else {
                return true;
              }
            })
            .forEach(n => {
              n.author = l.author;
              n.listingId = listingId;
              n.companyName = get(l, 'attributes.title', null);
              return container.push(n)
            });
        });

        const sortedContainer = container
          .map((item, index) => {
            if (item?.id) {
              return item;
            } else {
              item.id = index;
              return item;
            }
          })
          .sort((a, b) => b.id - a.id);

        setNews(sortedContainer);
      })
      .catch(e => console.log(e));
  }, [searchedCategory]);

  const screenWidth = typeof window !== 'undefined' && window.innerWidth;
  const slidesToShow = screenWidth && screenWidth < 768 ? 1.3 : 3;

  // Panel width relative to the viewport
  const panelMediumWidth = 50;
  const panelLargeWidth = 62.5;
  const cardRenderSizes = [
    '(max-width: 767px) 100vw',
    `(max-width: 1023px) ${panelMediumWidth}vw`,
    `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
    `${panelLargeWidth / 3}vw`,
  ].join(', ');

  const onHandleCurrentSlide = (index) => {
    setSlideIndex(index);
    setIsModalOpen(true);
  }

  const onHandleClosePopup = () => {
    setSlideIndex(-1);
    setIsModalOpen(false)
  }

  return news && news.length > 0 ? (
    <div className={css.sectionContent}>
      <h2 className={css.sectionTitle}>Latest posts</h2>

      <Swiper
        modules={[Navigation]}
        navigation={{
          nextEl: '.custom_next',
          prevEl: '.custom_prev',
        }}
        spaceBetween={10}
        slidesPerView={slidesToShow}
        onSwiper={swiper => { }}
        onSlideChange={() => { }}
      >
        <div className="custom_next">
          {' '}
          {/* we need to add our own arrows, SwiperJs doesn't show default ones  */}
          <ArrowForwardIosIcon style={{ fontSize: '40px' }} />
        </div>
        <div className="custom_prev">
          <ArrowBackIosNewIcon style={{ fontSize: '40px' }} />
        </div>
        {news.map((n, index) => {
          const link = get(n, 'link', null);
          const title = get(n, 'title', '');
          const imgUrl = get(n, 'image.url', null);

          return (
            <SwiperSlide key={index.toString()}>
              <div className={css.newsItem} onClick={() => onHandleCurrentSlide(index)}>
                <div>
                  <span className={css.title}>{title}</span>
                  <NewsImage
                    imgUrl={imgUrl}
                    link={null}
                    imageClassName={css.image}
                    iconClassName={css.newsIcon}
                  />
                  <p className={css.description}>{limitText(n?.description, 100)}</p>
                </div>
                <div className={css.authorInfo}>
                  <AvatarLarge className={css.authorAvatar} user={n?.author} disableProfileLink />
                  {!!n.companyName && (
                    <h3 className={css.authorName}>{n.companyName}</h3>
                  )}
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>

      <LatestNewsPopup
        onHandleCurrentSlide={onHandleCurrentSlide}
        onHandleClosePopup={onHandleClosePopup}
        news={news}
        slideIndex={slideIndex}
        isModalOpen={isModalOpen}
        onManageDisableScrolling={onManageDisableScrolling}
        searchedCategory={searchedCategory}
      />

    </div>
  ) : null;
}

export default LatestNewsSection;
